/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Targetjobservicev1Dependency } from '../models/Targetjobservicev1Dependency';
import { Targetjobservicev1Miscellanea } from '../models/Targetjobservicev1Miscellanea';
import { Targetjobservicev1SystemStat } from '../models/Targetjobservicev1SystemStat';
import { HttpFile } from '../http/http';

export class Targetjobservicev1Checks {
    'systemStat'?: Targetjobservicev1SystemStat;
    'dependencies'?: Array<Targetjobservicev1Dependency>;
    'miscellaneous'?: Array<Targetjobservicev1Miscellanea>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "systemStat",
            "baseName": "systemStat",
            "type": "Targetjobservicev1SystemStat",
            "format": ""
        },
        {
            "name": "dependencies",
            "baseName": "dependencies",
            "type": "Array<Targetjobservicev1Dependency>",
            "format": ""
        },
        {
            "name": "miscellaneous",
            "baseName": "miscellaneous",
            "type": "Array<Targetjobservicev1Miscellanea>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Targetjobservicev1Checks.attributeTypeMap;
    }

    public constructor() {
    }
}

